import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import routes from './routing/routes';
import store from './store';

export default () => ReactDOM.render(<Provider store={store}>{routes}</Provider>, document.getElementById('mount'));



// WEBPACK FOOTER //
// ./src/render.js